import * as firebase from "firebase";
import {getRegionName} from "@/utils/functionsRegion";

export const getRegionEnv = () => {
    const projectId = firebase.app().options['projectId'];
    const regionName = getRegionName();
    return `https://${regionName}-${projectId}.cloudfunctions.net`;
}